import { useCallback } from 'react';
import { useAppDispatch } from '@/app/hooks';
import { useLogoutMutation } from './authApi';
import { signedOut } from './authSlice';
import { tokenStorage } from './tokenStorage';

export function useSignOut() {
  const dispatch = useAppDispatch();
  const [logout, { isLoading }] = useLogoutMutation();

  const signOut = useCallback(async () => {
    const tokens = tokenStorage.get();

    if (tokens) {
      await logout({ refreshToken: tokens.refreshToken })
        .unwrap()
        .catch(() => undefined);
    }

    tokenStorage.clear();
    dispatch(signedOut());
  }, [dispatch, logout]);

  return { signOut, isSigningOut: isLoading };
}
